import qs from 'qs'
import axios from 'axios'
import md5 from 'js-md5'
import myOption from '../js/myOption.js'

// 登录请求函数
export function loginRequest (userName, password, type) {
  return axios({
    method: 'post',
    url: `${myOption.requestUrl}/auth`,
    data: qs.stringify({
      userName: userName.trim(),
      passWord: md5(password.trim()),
      isSspUser: type ? 1 : 0
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/loginRequest.js